import {EntryRowTypeHelpers} from 'common/query-builder/query-entry-section/row-types/types';
import {QueryGroupedEntry} from 'common/query-builder/query-entry-section/types';

// eslint-disable-next-line import/no-cycle
import {GroupedEntryRow} from './index';

export const helpers: EntryRowTypeHelpers<QueryGroupedEntry> = {
  component: GroupedEntryRow,
  isPlaceholder: ({entry}) => !entry.event.every((subEntry) => !!subEntry.event?.value),
  isIntermediatePlaceholder: ({entry}) => entry.event.some((subEntry) => !!subEntry.event?.value),
};
